import EnhancedTable from 'lib/designSystem/Table';
import { SocialSecurityArrear } from 'lib/types/models';
import React from 'react';

type SocialSecurityArrearTableProps = {
  arrears: SocialSecurityArrear[];
};

const SocialSecurityArrearTable = ({
  arrears,
}: SocialSecurityArrearTableProps) => {
  const tableData = arrears.map((a) => ({
    employeeInfo: {
      primary: a.employeeName,
      secondary: a.employeeIdentifier,
    },
    contactInfo: {
      primary: a.contact.name,
      secondary: a.contact.email,
    },
    productType: a.productType,
    institution: a.institution,
    monthInArrear: a.monthInArrear,
    letterDate: a.letterDate,
    claim: a.claim,
  }));
  return (
    <div>
      <EnhancedTable
        dataHeaders={[
          { key: 'employeeInfo', label: 'Afiliado', type: 'dual-text' },
          { key: 'productType', label: 'Tipo producto' },
          { key: 'institution', label: 'AFP o AFC' },
          { key: 'monthInArrear', label: 'Período a regularizar' },
          { key: 'letterDate', label: 'Fecha carta' },
          { key: 'contactInfo', label: 'Contacto', type: 'dual-text' },
          { key: 'claim', label: 'Demanda', type: 'status-chip' },
        ]}
        data={tableData}
        rowsPerPageDefault={25}
      />
    </div>
  );
};

export default SocialSecurityArrearTable;
